export default "__VITE_ASSET__BKjkwVmo__"